import { render } from "./affiliates.vue?vue&type=template&id=1d90f53e"
import script from "./affiliates.vue?vue&type=script&lang=js"
export * from "./affiliates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__